import axios from 'shared/tools/axiosMultisite';

const controller = new AbortController();

export const getAutoSuggest = async function getAutoSuggest(url) {
	// Abort pending request before the new one
	controller.abort();

	try {
		return await axios.get(url, {
			signal: controller.signal
		});
	} catch (err) {
		console.error(err);
	}
}

const AutoSuggestService = {
	getAutoSuggest,
};

export default AutoSuggestService;
